"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('headset', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    transform: "translate(2.000000, 6.000000)"
  }, _react.default.createElement("path", {
    d: "M40,24 L40,18.4615385 C40,8.26551231 31.9411255,0 22,0 C12.0588745,0 4,8.26551231 4,18.4615385 L4,24",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M36,22 L40,22 L40,36 L36,36 C33.790861,36 32,34.209139 32,32 L32,26 C32,23.790861 33.790861,22 36,22 Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M40,26 L42,26 C43.1045695,26 44,26.8954305 44,28 L44,30 C44,31.1045695 43.1045695,32 42,32 L40,32 L40,26 Z",
    fill: props.outStrokeColor
  }), _react.default.createElement("path", {
    d: "M0,26 L2,26 C3.1045695,26 4,26.8954305 4,28 L4,30 C4,31.1045695 3.1045695,32 2,32 L0,32 L0,26 Z",
    fill: props.outStrokeColor,
    transform: "translate(2.000000, 29.000000) scale(-1, 1) translate(-2.000000, -29.000000) "
  }), _react.default.createElement("path", {
    d: "M4,22 L8,22 C10.209139,22 12,23.790861 12,26 L12,32 C12,34.209139 10.209139,36 8,36 L4,36 L4,22 Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }))));
});

exports.default = _default;